import { Flex, Form, Input } from 'antd'
import React, { useCallback, useEffect, useRef } from 'react'
import { useIntl } from 'react-intl'
import { Save } from '@/components/UI'

const ResetPINForm = ({ onSubmit, loading, withSubmitAction = true }) => {
  const { formatMessage } = useIntl()
  const [form] = Form.useForm()
  const passwordRef = useRef(null)

  const handleSubmit = useCallback(
    (values) => {
      onSubmit({ values, callback: () => form.resetFields() })
    },
    [onSubmit, form],
  )

  useEffect(() => {
    if (passwordRef.current) {
      setTimeout(() => {
        passwordRef.current?.focus()
      }, 400)
    }
  }, [passwordRef])

  return (
    <Form form={form} onFinish={handleSubmit} layout="vertical" name="ResetPINForm">
      <Form.Item
        label={formatMessage({ id: 'please_input_your_password_to_reset_pin' })}
        name="password"
        rules={[
          {
            required: true,
            message: formatMessage({ id: 'users.please_input_your_password' }),
          },
        ]}
      >
        <Input.Password
          placeholder={formatMessage({ id: 'users.please_input_your_password' })}
          ref={passwordRef}
        />
      </Form.Item>
      {withSubmitAction && (
        <Flex justify="end" className="mt-4">
          <Save id="btn-reset-pin" htmlType="submit" loading={loading} />
        </Flex>
      )}
    </Form>
  )
}

export default ResetPINForm
